import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface TagProps {
  children: ReactNode;
  tone?: 'cyan' | 'neutral' | 'error';
  withDot?: boolean;
  className?: string;
}

const tones: Record<NonNullable<TagProps['tone']>, string> = {
  cyan: 'border-outline text-cyan',
  neutral: 'border-outline text-on-surface-variant',
  error: 'border-error text-error',
};

export function Tag({ children, tone = 'cyan', withDot = false, className }: TagProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-full border bg-surface-container px-3 py-1',
        'text-[11px] font-semibold uppercase tracking-[0.08em]',
        tones[tone],
        className,
      )}
    >
      {withDot ? (
        <span
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            tone === 'error' ? 'bg-error' : 'bg-cyan encryption-glow',
          )}
        />
      ) : null}
      {children}
    </span>
  );
}
